import * as React from 'react';
import '../../styles/css/index.css';
import { ImageSource } from '@models/image-source';
import styled from 'styled-components';

export interface Props {

}

export const HeaderImage = styled.img<{ hasChildren?: boolean }>`
  max-height: 40px;
  max-width: ${({ hasChildren }) => hasChildren ? '80%' : '100%'};
`;

const imageSrc = ImageSource.brandLogo;

class Header extends React.Component<Props> {
    public render() {
        return (
            <div className='header'>
                <div className='header-content'>
                    <HeaderImage src={imageSrc} hasChildren={!!this.props.children}/>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.tsx